export function createTaskTemplateApi({ apiUrl, getToken }) {
    const headers = (json = true) => {
        const h = { Authorization: `Bearer ${getToken()}` };
        if (json) h["Content-Type"] = "application/json";
        return h;
    };

    return {
        async fetchTemplates() {
            const res = await fetch(`${apiUrl}/task-templates`, { headers: headers(false) });
            const data = await res.json().catch(() => ({}));
            if (!res.ok) throw new Error(data.message || "Failed to fetch templates");
            return Array.isArray(data.data) ? data.data : [];
        },

        async createTemplate(payload) {
            const res = await fetch(`${apiUrl}/task-templates`, {
                method: "POST",
                headers: headers(),
                body: JSON.stringify(payload),
            });
            const data = await res.json().catch(() => ({}));
            if (!res.ok) throw new Error(data.message || "Failed to save template");
            return data.data;
        },

        async updateTemplate(id, payload) {
            const res = await fetch(`${apiUrl}/task-templates/${id}`, {
                method: "PUT",
                headers: headers(),
                body: JSON.stringify(payload),
            });
            const data = await res.json().catch(() => ({}));
            if (!res.ok) throw new Error(data.message || "Failed to update template");
            return data.data;
        },

        async deleteTemplate(id) {
            const res = await fetch(`${apiUrl}/task-templates/${id}`, {
                method: "DELETE",
                headers: headers(false),
            });
            const data = await res.json().catch(() => ({}));
            if (!res.ok) throw new Error(data.message || "Failed to delete template");
        },
    };
}
